import { InjectionToken } from '@angular/core';
import { DatastoreFake } from './datastore';

export interface DatastoreFakeConfig {
  readonly debug: boolean;
  constructInitialState(datastore: DatastoreFake, authUid: number): void;
}

export const DATASTORE_FAKE_CONFIG = new InjectionToken<DatastoreFakeConfig>(
  'DatastoreFake Configuration',
);
